define('modules/htmlad/form/ean_code_form/htmlad_form_ean_code_form_model',['backbone'], function (Backbone) {
  'use strict';
  var Model = Backbone.Model.extend({
    defaults: {
      content: false,
      price: false,
      ean_code: null,
      form_cleared: false
    }
  });

  return Model;
});

